import { MapPin, Phone, Mail, ArrowUp } from 'lucide-react';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer data-testid="footer" className="bg-earth-100 text-white">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-display text-2xl mb-4">Gite Riquewihr</h3>
            <p className="font-body text-sm text-white/60 leading-relaxed mb-6">
              Appartements de charme dans des maisons du XVIe siecle,
              au coeur de la Route des Vins d'Alsace.
            </p>
            <div className="flex gap-4">
              {['FR', 'DE', 'EN'].map((lang) => (
                <span
                  key={lang}
                  className={`w-8 h-8 flex items-center justify-center border font-body text-xs ${
                    lang === 'FR'
                      ? 'border-gold text-gold'
                      : 'border-white/20 text-white/40 cursor-not-allowed'
                  }`}
                >
                  {lang}
                </span>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-display text-lg mb-6">Navigation</h4>
            <div className="grid grid-cols-2 gap-3">
              {[
                { label: 'Accueil', href: '#accueil' },
                { label: 'Appartements', href: '#appartements' },
                { label: 'Tarifs', href: '#tarifs' },
                { label: 'Riquewihr', href: '#decouvrir' },
                { label: 'Avis', href: '#avis' },
                { label: 'Contact', href: '#contact' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  className="font-body text-sm text-white/60 hover:text-gold transition-colors duration-300"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-lg mb-6">Contact</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="text-gold mt-1 flex-shrink-0" />
                <p className="font-body text-sm text-white/60">
                  4, Rue du General De Gaulle<br />
                  Cour Renaissance<br />
                  F-68340 RIQUEWIHR
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={16} className="text-gold flex-shrink-0" />
                <a href="tel:+33632345143" className="font-body text-sm text-white/60 hover:text-gold transition-colors">
                  +33 6 32 34 51 43
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={16} className="text-gold flex-shrink-0" />
                <a href="mailto:info@gite-riquewihr.com" className="font-body text-sm text-white/60 hover:text-gold transition-colors">
                  info@gite-riquewihr.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl py-6 flex items-center justify-between">
          <p className="font-body text-xs text-white/40">
            &copy; {new Date().getFullYear()} Gite Riquewihr &mdash; M. Cyril GREWIS-RELIEF. Tous droits reserves.
          </p>
          <button
            onClick={scrollToTop}
            data-testid="scroll-to-top-btn"
            className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors"
          >
            <ArrowUp size={16} className="text-white/60" />
          </button>
        </div>
      </div>
    </footer>
  );
}
